export default __webpack_public_path__ + "static/media/deleteIcon.6f6b98ed.svg";